import React, { ChangeEvent, useEffect, useRef, useState } from "react";

// Components
import Button from "components/UiKit/Button";
import CircleStencil from "components/CircleStencil";
import { Cropper, CropperPreview, CropperPreviewRef, CropperRef } from "react-advanced-cropper";

// Style
import "react-advanced-cropper/dist/style.css";

// Actions
import { updateAvatarUser } from "pages/Account/reducer";

// Classname
import clsx from "clsx";

// Lib
import { useAppDispatch } from "lib/hooks/useDispatch";

export const Crop: React.FC<any> = (props) => {
  const dispatch = useAppDispatch();
  const previewRef = useRef<CropperPreviewRef>(null);
  const { actions } = props;

  const [file, setFile] = useState({});
  const [image, setImage] = useState<any>({
    src: "",
    type: ""
  });

  useEffect(() => {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    return () => {
      if (image && image?.src) {
        URL.revokeObjectURL(image.src);
      }
    };
  }, [image]);

  const handlerCrop = () => {
    if (file) {
      dispatch(updateAvatarUser(file));
    }
  };

  const onCrop = (preview: CropperRef) => {
    const canvas = preview?.getCanvas();
    if (canvas) {
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], "croppedImg.png", { type: blob.type });
          setFile(file);
        }
      }, image.type);
    }

    previewRef.current?.update(preview);
  };

  const handlerClose = () => {
    actions.closeCallback();
    setImage({
      src: "",
      type: ""
    });
    setFile({});
  };

  const handlerUpload = (event: ChangeEvent<HTMLInputElement>) => {
    // Reference to the DOM input element
    const { files } = event.target;

    const maxSize = 5 * (1024 * 1024);
    const size = files
      ? files[0]?.size
      : 0;

    if (size > maxSize) {
      alert("Image is too big!");
      event.target.value = "";
    }

    // Ensure that you have a file before attempting to read it
    if (files && files[0]) {
      // Create the blob link to the file to optimize performance:
      const blob = URL.createObjectURL(files[0]);

      // Get the image type from the extension. It's the simplest way, though be careful it can lead to an incorrect result:
      setImage({
        src: blob,
        type: files[0].type
      });
      setFile(files[0]);
    }
    // Clear the event target value to give the possibility to upload the same image:
    event.target.value = "";
  };

  const cnPreview = clsx(
    "crop__preview",
    !previewRef.current ? "crop__preview--active" : ""
  );

  return (
    <div className="crop">
      <div className="flex flex-ai-start flex-ai-center-mobile flex-direction-column-mobile mb15">
        <div className="flex flex-ai-center flex-direction-column">
          <h4 className="crop__title mb20">Default usage</h4>
          <div className="crop__border-avatar">
            <Cropper
              src={image.src}
              onUpdate={onCrop}
              className="cropper"
              stencilComponent={CircleStencil}
            />
          </div>
        </div>
        <div className="flex flex-ai-center flex-direction-column ml10">
          <h4 className="crop__title mb20">Preview</h4>
          <div className={cnPreview}>
            <CropperPreview
              ref={previewRef}
              className="preview"
            />
          </div>
        </div>
      </div>

      <div className="crop__buttons flex flex-jc-end flex-ai-center">
        <Button
          isSvg
          type="file"
          variable="icon"
          icon="uploadSvg"
          onPress={handlerUpload}
          title="Upload image user"
          className="crop__upload-btn mr10"
        />
        <Button
          color="error"
          label="Close"
          className="mr10"
          variable="outline"
          onPress={handlerClose}
        />
        <Button
          label="Save"
          variable="info"
          onPress={handlerCrop}
        />
      </div>
    </div>
  );
};

export default Crop;
